import { NgModule } from "@angular/core";
import { LoadingComponent } from "./loading/loading.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatBadgeModule } from "@angular/material/badge";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { DiscountCodeComponent } from "./discount-code/discount-code.component";
import { PhonePipe } from "./../../util/phone.pipe";
import { PhoneComponent } from "./phone/phone.component";
import { HighchartsChartModule } from "highcharts-angular";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AddressAutocompleteComponent } from "./address-autocomplete/address-autocomplete.component";
import { MatRadioModule } from "@angular/material/radio";
import { CivilityRadioButtonComponent } from "./civility-radio-button/civility-radio-button.component";

const angularMaterialModules = [
    MatAutocompleteModule,
    MatBadgeModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatRadioModule,
    MatTooltipModule,
];
const angularModules = [
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
];
@NgModule({
    imports: [
        angularModules,
        angularMaterialModules,
        TranslateModule,
        CommonModule,
        HighchartsChartModule,
        LoadingComponent,
    ],
    declarations: [
        DiscountCodeComponent,
        PhonePipe,
        PhoneComponent,
        AddressAutocompleteComponent,
        CivilityRadioButtonComponent,
    ],
    exports: [
        LoadingComponent,
        DiscountCodeComponent,
        TranslateModule,
        angularMaterialModules,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        PhonePipe,
        PhoneComponent,
        FlexLayoutModule,
        AddressAutocompleteComponent,
        PhoneComponent,
        CivilityRadioButtonComponent,
    ],
})
export class MainComponentModule { }
